import { useEffect, useState } from "react";

const storeUrls = {
  tr: `${process.env.REACT_APP_STORE_URL}customer/login`,
  de: `${process.env.REACT_APP_GLOBAL_STORE_URL}customer/login`,
  en: `${process.env.REACT_APP_STORE_URL}customer/login`,
};

export const useStoreUrl = (lang) => {
  const [storeUrl, setStoreUrl] = useState(storeUrls[lang] || storeUrls["tr"]);

  useEffect(() => {
    setStoreUrl(storeUrls[lang] || storeUrls["tr"]);
  }, [lang]);

  return storeUrl;
};
